
import { Vue, Component, Prop } from 'vue-property-decorator'
import DailyDealBannerComponent from '@mg/web-components/Banners/DailyDealBanner'
import { BannerData } from '@mg/web-components/Banners/types'
import {
  GQLPageBannerDailyDealBannerAttributes,
  GQLProduct,
  GQLUser,
  GQLConfig,
} from '~/graphql/__generated__/interfaces'
import { GET_BASIC_USER_INFO } from '~/graphql/gql/user'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'
import { GQLLocalAccount } from '~/graphql/__generated__/interfacesLocal'
import { GET_CONFIG } from '~/graphql/gql/config'
import { GET_PRODUCTS_FOR_BANNER } from '~/graphql/gql/product'
import { getRrpPrice } from '~/utils/productPriceSource'
import AddToCartButton from '~/components/AddToCartButton.vue'
import getVipIcon from '~/utils/getVipIcon'
import showVipFeatures from '~/utils/showVipFeatures'

@Component<DailyDealBanner>({
  apollo: {
    account: GQL_LOCAL_ACCOUNT,
    getConfig: {
      fetchPolicy: 'cache-only',
      query: GET_CONFIG,
    },
    products: {
      query: GET_PRODUCTS_FOR_BANNER,
      skip() {
        return !this.bannerAttributes.productId
      },
      variables() {
        const ids = this.bannerAttributes.productId
          ? [Number(this.bannerAttributes.productId)]
          : []
        return { ids, ignoreMissing: true }
      },
    },
    user: {
      query: GET_BASIC_USER_INFO,
      skip() {
        return !this.$shopConfig.user.id && !this.account?.isLogged
      },
    },
  },
  components: {
    AddToCartButton,
    DailyDealBannerComponent,
  },
})
export default class DailyDealBanner extends Vue {
  @Prop({ required: true, type: Object }) bannerData: BannerData
  @Prop(Boolean) isMobile: boolean

  products: GQLProduct[]
  user: GQLUser
  account: GQLLocalAccount
  getConfig: GQLConfig
  getVipIcon = getVipIcon
  showVipFeatures = showVipFeatures
  getRrpPrice = getRrpPrice

  get bannerAttributes() {
    return this.bannerData
      .bannerAttributes as GQLPageBannerDailyDealBannerAttributes
  }

  get product() {
    const products = this.products || []
    return products[0]
  }

  get vipType() {
    return this.showVipFeatures(this.user?.vipType) ? this.user?.vipType : ''
  }

  get translations() {
    return {
      action_price_valid_to: this.$t('common.action_price_valid_to'),
      added: this.$t('common.cta_added'),
      buy_now: this.$t('common.cta_buy_now'),
      language_key: this.getConfig?.shopConfig.nxtLanguageKey,
      offer_validity: this.$t('common.offer_validity'),
      product_box_sold_out: this.$t('common.product-box-sold-out'),
      sold_out: this.$tc('common.sold_out'),
      time_days_few: this.$t('common.time-days_few'),
      time_days_many: this.$t('common.time-days_many'),
      time_days_one: this.$t('common.time-days_one'),
      time_days_other: this.$t('common.time-days_other'),
      time_days_two: this.$t('common.time-days_two'),
    }
  }
}
